module.exports = __webpack_public_path__ + "static/media/merchant-icon.af56de49.svg";